import { clsx } from 'clsx';
import Image from 'next/image';

export type flagSizes = 'small' | 'medium' | 'large' | 'xlarge';

export interface FlagProps {
  size?: flagSizes | { width: number; height: number };
  countryCode?: string;
  className?: string;
  basePath?: string;
  alt?: string;
  priority?: boolean;
  dataTestId?: string;
}

const sizes: {
  [size in flagSizes]: { width: number; height: number };
} = {
  small: { width: 33, height: 19 },
  medium: { width: 45, height: 26 },
  large: { width: 72, height: 42 },
  xlarge: { width: 89, height: 52 },
};

export function Flag({
  size = 'small',
  countryCode = 'us',
  basePath = '',
  className,
  priority = false,
}: FlagProps) {
  const sizeProperties = typeof size === 'string' ? sizes[size] : size;

  const inLowerCaseCode = countryCode.toLowerCase();

  return (
    <Image
      alt={`${inLowerCaseCode}-flag`}
      src={`${basePath}/images/flags/${inLowerCaseCode}.png`}
      className={clsx('h-fit', className)}
      priority={priority}
      {...sizeProperties}
      data-testid={`${inLowerCaseCode}-flag`}
    />
  );
}
